const plans = {
  trial: 'trial',
  free: 'free',
  premium: 'premium',
}
export type Plans = keyof typeof plans | null;

/**
 * トライアルかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
 export const isTrial = (serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "trial" === serviceContractType;
}

/**
 * 再トライアル（トライアル終了後の再獲得キャンペーン等）かどうかを返す
 * @param serviceContractTypeDetail
 * @returns
 */
export const isReTrial = (serviceContractTypeDetail?: 'retrial' | null) => {
  return serviceContractTypeDetail === 'retrial';
}

/**
 * フリープランかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
export const isFree = (serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "free" === serviceContractType;
}

/**
 * プレミアムプランかどうかを返す
 * @param serviceContractType 
 * @returns 
 */
export const isPremium  =(serviceContractType?: Plans) => {
  if(!serviceContractType || !plans[serviceContractType]) throw new Error('invalid service contract type');
  return "premium" === serviceContractType;
}

/**
 * 次契約が有料プラン（プレミアム／エンタープライズ）かどうかを返す
 * エンタープライズは service_contract_type が 'premium' となるため、enterprise_license_id の有無で判定する
 * @param account
 * @returns
 */
export const hasNextPaidContract = (account?: {
  next_service_contract_type?: Plans,
  next_service_contract_enterprise_license_id?: string | null,
} | null) => {
  if(!account) return false;
  if(account.next_service_contract_enterprise_license_id) return true;
  const nextServiceContractType = account.next_service_contract_type;
  return !!nextServiceContractType && isPremium(nextServiceContractType);
}

/**
 * ベータ版（クラウド黒板）工事を作成できるアカウントかどうかを返す
 * トライアルでも次契約がプレミアム／エンタープライズであれば作成できる
 * @param account
 * @returns
 */
export const canUseBetaConstruction = (account?: {
  service_contract_type?: Plans,
  next_service_contract_type?: Plans,
  next_service_contract_enterprise_license_id?: string | null,
} | null) => {
  const serviceContractType = account?.service_contract_type;
  // isTrial() は不正値で例外を投げるため、値が取れないうちは作成不可として扱う
  if(!serviceContractType) return false;
  if(!isTrial(serviceContractType)) return true;
  return hasNextPaidContract(account);
}
